
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/academy/learn-blockchain",
      function () {
        return require("private-next-pages/academy/learn-blockchain/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/academy/learn-blockchain"])
      });
    }
  